import ObgynNoteForm from './ObgynNoteForm';

// Registry mapping doctor field IDs to custom note forms
// Keys are strings to match `String(doctorFieldId)` in NoteModal
export const noteFormRegistry = {
    '6': ObgynNoteForm, // OBGYN
};
